import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { ShipmentFiltersInitialState, ShipmentFiltersLoad, ShipmentFiltersUpdate } from './shipment-filters.actions';
import { ShipmentFiltersState } from './shipment-filters.state';
import { ShipmentFilterName } from '../constants';

@Injectable({ providedIn: 'root' })
export class ShipmentFiltersFacade implements LoadDataFacade, SetInitialStateFacade {
  items$: Observable<ShipmentFilterName[]> = this.store.select(ShipmentFiltersState.getItems);
  loaded$: Observable<boolean> = this.store.select(ShipmentFiltersState.getLoaded);

  constructor(private store: Store) {}

  loadAll(): void {
    this.store.dispatch(new ShipmentFiltersLoad());
  }

  updateFilters(filters: ShipmentFilterName[]): void {
    this.store.dispatch(new ShipmentFiltersUpdate(filters));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentFiltersInitialState());
  }
}
